import React, { useState } from "react";
import Logo from "@/components/Logo";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { consumeOAuthRedirect } from "@/lib/oauthRedirect";
import { errText } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cargando, setCargando] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      const data = await login(email, password);
      const rol = data?.usuario?.rol;
      if (rol === "admin" || rol === "closer") {
        // Equipo: no pasa por onboarding; si venía del consentimiento OAuth, vuelve ahí.
        nav(consumeOAuthRedirect() || "/admin");
      } else {
        // Cliente: sigue el onboarding/perfil/bienvenida obligatorios; el retorno OAuth se consume al final (Mesa).
        nav("/boot");
      }
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="min-h-screen bg-negro flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <Logo variant="full" height={120} className="mb-12 mx-auto block" />
        <h1 className="titulo text-5xl mb-3">Hola de nuevo.</h1>
        <p className="text-gris mb-10">Entrá y seguí donde lo dejaste.</p>

        <form onSubmit={submit} className="space-y-4">
          <input className="input-dark" type="email" placeholder="Tu mail" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
          <input className="input-dark" type="password" placeholder="Tu contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
          <button className="btn-dorado w-full mt-2" disabled={cargando} data-testid="login-submit">{cargando ? "ENTRANDO…" : "ENTRAR"}</button>
        </form>

        <div className="flex justify-between mt-8 text-sm">
          <Link to="/recuperar" className="text-gris hover:text-dorado transition-colors" data-testid="link-recuperar">Me olvidé la contraseña</Link>
          <Link to="/registro" className="text-gris hover:text-dorado transition-colors" data-testid="link-registro">Crear cuenta</Link>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-[#777]">
          <Link to="/privacidad" className="hover:text-dorado">Privacidad</Link>
          <Link to="/terminos" className="hover:text-dorado">Términos</Link>
          <Link to="/soporte" className="hover:text-dorado">Soporte</Link>
        </div>
      </motion.div>
    </div>
  );
}
